<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
      <div class="tu-class">

        <el-form :model="formData" ref="ruleForm" :rules="rules" label-position="left" label-width="80px" v-hasPermi="['personalOffice:myMission:shipmentOutEntrepot']" size="default">
          <div class="table-container">
            <h2 align="center">发货申请单</h2>
            <table class="table-layout">
              <tbody>
              <tr>
                <td class="table-cell" colspan="2">购货公司</td>
                <td class="table-cell" colspan="2">
                  <input v-model="formData.companyName" class="text-input">
                </td>
                <td class="table-cell" colspan="2">申请原因</td>
                <td class="table-cell" colspan="2">
                  <input type="text" v-model="formData.applyCause" class="text-input">
                </td>
              </tr>
              <tr>
                <td class="table-cell" colspan="2">使用设备及描述</td>
                <td class="table-cell" colspan="2">
                  <input type="text" v-model="formData.useDevice" class="text-input">
                </td>
                <td class="table-cell" colspan="2">备注</td>
                <td class="table-cell" colspan="2">
                  <input type="text" v-model="formData.remark" class="text-input">
                </td>
              </tr>
              <tr>
                <td class="table-cell" colspan="8">申请内容</td>
              </tr>
              <tr>
                <td class="table-cell" style="height: 70px !important">运营商</td>
                <td class="table-cell">卡类型</td>
                <td class="table-cell">套餐内容(注明配套餐出货或用户充值)</td>
                <td class="table-cell">数量</td>
                <td class="table-cell">单位</td>
                <td class="table-cell">单价(元)</td>
                <td class="table-cell">总金额(元)</td>
                <td class="table-cell">操作</td>
              </tr>
              <tr v-for="(content, index) in formData.contentList" :key="index">
                <td class="table-radio" style="height: 70px !important">
                  <template>
                    <el-radio v-model="content.operatorName" label="0">中国移动</el-radio>
                    <el-radio v-model="content.operatorName" label="1">中国联通</el-radio>
                    <el-radio v-model="content.operatorName" label="2">中国电信</el-radio>
                  </template>
                </td>
                <td class="table-checkbox">
                  <template>
                    <el-checkbox-group v-model="content.cardList">
                      <el-checkbox label="插拔卡三切"></el-checkbox>
                      <el-checkbox label="贴片卡5*6"></el-checkbox>
                      <el-checkbox label="贴片卡2*2"></el-checkbox>
                      <el-checkbox label="定向"></el-checkbox>
                    </el-checkbox-group>
                  </template>
                </td>
                <td class="table-cell">
                  <input type="text" v-model="content.packageContent" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model.number="content.quantity" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model.number="content.units" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model="content.unitPrice" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model.number="content.grossAmount" class="text-input">
                </td>
                <td class="table-cell">

                </td>
              </tr>

              <tr>
                <td class="table-cell" colspan="2">运输方式</td>
                <td class="table-cell" colspan="2">
                  <template>
                    <el-radio v-model="formData.modeOfTransport" label="0">自提</el-radio>
                    <el-radio v-model="formData.modeOfTransport" label="1">送货</el-radio>
                    <el-radio v-model="formData.modeOfTransport" label="2">快递寄付</el-radio>
                    <el-radio v-model="formData.modeOfTransport" label="3" style="margin-left:-28px">快递到付</el-radio>
                  </template>
                </td>
                <td class="table-cell">要求发货日期</td>
                <td class="table-cell" colspan="3">
                  <el-date-picker v-model="formData.deliveryDate" type="date" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </td>
              </tr>
              <tr>
                <td class="table-cell" colspan="2">收货地址</td>
                <td class="table-cell" colspan="6">
                  <input type="text" v-model="formData.shippingAddress" class="text-input">
                </td>
              </tr>
              <tr>
                <td class="table-cell" colspan="2">收货人</td>
                <td class="table-cell" colspan="2">
                  <input type="text" v-model="formData.consignee" class="text-input">
                </td>
                <td class="table-cell">收货人电话</td>
                <td class="table-cell" colspan="3">
                  <input type="text" v-model="formData.receivingPhone" class="text-input">
                </td>
              </tr>
              <tr>
                <td class="table-cell" colspan="2">是否付款
                </td>
                <td class="table-cell" colspan="2">
                  <template>
                    <el-radio v-model="formData.whetherToPay" label="0">是</el-radio>
                    <el-radio v-model="formData.whetherToPay" label="1">否</el-radio>
                  </template>
                </td>
                <td class="table-cell">付款方式</td>
                <td class="table-cell" colspan="3">
                  <template>
                    <el-radio v-model="formData.payMode" label="0">对公转账</el-radio>
                    <el-radio v-model="formData.payMode" label="1">微信</el-radio>
                    <el-radio v-model="formData.payMode" label="2">支付宝</el-radio>
                    <el-radio v-model="formData.payMode" label="3">赠送</el-radio>
                  </template>
                </td>
              </tr>
              <tr>
                <td class="table-cell" rowspan="2" colspan="2">支付凭证或申请说明（截图）
                </td>
                <td class="table-cell" colspan="6" rowspan="2" style="height: 100px !important">
                  <el-upload class="avatar-uploader" :action="url" accept=".jpg,.png" :show-file-list="false" :on-success="handlePayVoucherImgSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="formData.payVoucher" :src="formData.payVoucher" class="avatar">
                    <i v-if="!formData.payVoucher" class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </td>
              </tr>
              <tr></tr>
              </tbody>
            </table>
          </div>
        </el-form>
        <hr>
        <el-form :model="formData2" ref="ruleForm2" :rules="rules2" label-position="left" label-width="80px" size="default">

          <div class="table-container">
            <h2 align="center">出库单</h2>
            客户名称：<input type="text" style="border: none" v-model="formData2.customerName" >
            开单日期：<el-date-picker v-model="formData2.billingDate" type="date" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            <table class="table-layout">
              <tbody>
                <tr>
                  <td class="table-cell">序号</td>
                  <td class="table-cell">品名</td>
                  <td class="table-cell">数量</td>
                  <td class="table-cell">单位</td>
                  <td class="table-cell">价格</td>
                  <td class="table-cell">货款</td>
                  <td class="table-cell">备注</td>
                </tr>

                <tr v-for="(content, index) in formData2.contentList" :key="index">
                  <td class="table-cell">{{index+1}}</td>
                  <td class="table-cell">
                    <input type="text" v-model="content.categoryName" class="text-input">
                  </td>
                  <td class="table-cell">
                    <input type="text" v-model.number="content.quantity" class="text-input">
                  </td>
                  <td class="table-cell">
                    <input type="text" v-model="content.units" class="text-input">
                  </td>
                  <!--<td class="table-cell">
                    <input type="text" v-model="content.unitPrice" class="text-input">
                  </td>
                  <td class="table-cell">
                    <input type="text" v-model="content.paymentGoods" class="text-input">
                  </td>-->
                  <td class="table-cell" colspan="3">
                    <input type="text" v-model="content.remark" class="text-input-left">
                  </td>
                </tr>

                <tr>
                  <td class="table-cell" colspan="2">合计</td>
                  <td class="table-cell"><input type="text" v-model="formData2.total" class="text-input"></td>
                  <td class="table-cell" colspan="4">.物联卡机卡绑定，更换设备或被销卡，请联系客服查询；请勿插在手机等移动端使用，经检测将被关停。
                    .本产品仅限于在规定的广告机设备上使用，请勿用作他途。
                  </td>
                </tr>
                <tr>
                  <td class="table-cell">备注</td>
                  <td class="table-cell" colspan="6"><input type="text" v-model="formData2.remark" class="text-input-left"></td>
                </tr>

              </tbody>
            </table>
            <div>制单：{{documenter}}  财务：{{financial}}  仓库：{{entrepot}}   客户签名:</div>
          </div>
        </el-form>

      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 审批意见
        <div class="nr-class">
          <el-select v-model="queryParams.status" filterable placeholder="审批结果" clearable>
            <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <p class="yjp-class">
            <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width:50%"></el-input>
          </p>
          <el-button type="primary" @click="submitFlowComment" style="margin-top: 20px;">提交</el-button>
        </div>
      </h3>
    </div>
  </div>
</template>
<script>
  import { processInstanceImage } from "@/api/api.js";
  import { submitTask , processFromData } from "@/api/api.js";

  export default {
    name:'flowShipment',
    data() {
      return{
        formData: {},
        userName: null,
        srcList: [
          "https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg",
          "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
        ],
        rules: {},
        processId:'',
        id:'',
        str:"",
        queryParams:{
          remark:""
        },
        source:[
          {
            value:1,
            label:"同意"
          },
          {
            value:2,
            label:"不同意"
          },
        ],
        url: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/uploadImage',
        gaibianurl: process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_API + '/upload/image/',
        file:"",

        formData2: {
          id: null,
          customerName: null,
          billingDate: null,
          remark: null,
          documenter: null,
          financial: null,
          entrepot: null,
          number: null,
          customerSignature: null,
          total: null,
          status: null,
          shipmentId: null,
          flowId: null,
          contentList: [
                  {
                    id: null,
                    categoryName: null,
                    quantity: null,
                    units: null,
                    unitPrice: null,
                    paymentGoods: null,
                    remark: null,
                    outEntrepotId: null
                  },
                  {
                    id: null,
                    categoryName: null,
                    quantity: null,
                    units: null,
                    unitPrice: null,
                    paymentGoods: null,
                    remark: null,
                    outEntrepotId: null
                  },
                  {
                    id: null,
                    categoryName: null,
                    quantity: null,
                    units: null,
                    unitPrice: null,
                    paymentGoods: null,
                    remark: null,
                    outEntrepotId: null
                  },
                  {
                    id: null,
                    categoryName: null,
                    quantity: null,
                    units: null,
                    unitPrice: null,
                    paymentGoods: null,
                    remark: null,
                    outEntrepotId: null
                  }
          ]
        },
      }
    },

    methods: {
      // 获取数据
      initDataProcessImage(){
        let params ={
          processInstanceId:this.processId
        }
        processInstanceImage(params).then(res=>{
          this.str = res.data
        });
      },
      initData() {
        let params = {
          processInstanceId: this.processId,
          taskId: this.id
        };
        processFromData(params).then((res) => {
          this.formData = res.data.data.shipmentRequest;
          if (res.data.data.outEntrepot) {
            this.formData2 = res.data.data.outEntrepot;
          }
        });
      },
      // 提交
      submitFlowComment(){
        if (!this.queryParams.remark || !this.queryParams.status) {
          return this.$message.error("请输入审批内容或结果");
        }
        let params = {
          ...this.queryParams,
          taskId: this.id,
          userName: this.userName,
          createSysUser: this.createSysUser
        }
        params.customerInformationDto = this.formData;
        params.outEntrepot = this.formData2;
        submitTask(params).then(res=>{
          if(res.data.code == 200){
            this.$store.dispatch('tagsView/delView', this.$route);
            this.$router.push({ path: `/personalOffice/myMission` });
            this.$notify({
              title: '成功',
              message: '审批成功',
              type: 'success'
            });
          }
        })
      },

    },
    created() {
      this.isFinancial = this.$store.getters.user.roleType == "0" || this.$store.getters.user.roleType == "1" || this.$store.getters.user.roleType == "5";
      this.processId =  this.$route.query.processId ;
      this.id =  this.$route.query.id ;
    },
    mounted() {
      this.initDataProcessImage()
      this.initData()
    },
  };
</script>
<style scoped lang="less">
  .el-row {
    //   margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 0px;
    //   min-height: 36px;
    border: 1px solid #4d4d4d;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 46px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .grid-content-image {
    border-radius: 4px;
    min-height: 300px;
    padding: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  div.table-container {
    margin-top: 50px;
    margin-left: 220px;
    max-width: 1200px;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid black;
    table.table-layout {
      table-layout: fixed;
      border-collapse: collapse;
      width: 1080px;

      td.table-cell {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
        text-align: center;
      }
    }
  }
  .table-checkbox,
  .table-radio {
    display: table-cell;
    border: 1px solid black;
    text-align: left;
  }

  .add-button {
    margin-top: -340px;
    margin-right: -10px;
    float: right;
    position: relative;
  }
  .save {
    margin-top: 50px;
    margin-left: 750px;
    position: relative;
  }
  .text-input {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
  }
  .text-input-left {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
  }
  .radio-input {
    vertical-align: middle;
    margin-top: -2px;
    margin-bottom: 1px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    // line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
    .nr-class{
      margin-top: 20px;
      margin-left: 10px;
    }
    .yjp-class{
      margin-top: 20px;
    }
  }
</style>


